import { render } from "./PendingRecords.vue?vue&type=template&id=f782028e"
import script from "./PendingRecords.vue?vue&type=script&lang=js"
export * from "./PendingRecords.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__